import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Grid,
} from '@material-ui/core';
import {
  BackdropCircular,
  Breadcrumb
} from 'components';
import { getQuoteProProductsBySearchCriteriaApi } from 'api';
import { setFinalPageData } from 'redux/actions/quote';
import QuoteGroupInfo from '../QuotePatientDashboard/QuoteGroupInfo';
import QuoteSummaryTable from './QuoteSummaryTable';
import QuoteSummaryPatient from './QuoteSummaryPatient';
import QuotePatientGroupSummaryCard from './QuotePatientGroupSummaryCard';


const QuoteGroupPatientsSummary = () => {
  const history = useHistory();
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const dispatch = useDispatch();
  const isPatientGroupActive = location.pathname.includes('/quoting/group/');

  const {
    quoteProducts,
    loadingDeleteQuoteItem,
    loadingConvertQuote,
    loadingQuoteTotals,
    quoteProductsLoading,
    loadingCustomerPushCart,
    loadingActiveMagentoCart,
    loadingAddItemsToQuote,
    loadingCheckout,
    patientsGroupCart,
    loadingPatientsGroupCart,
    currentMarketingSegment
  } = useSelector((state: IReduxState) => state.quote);

  const loading = loadingDeleteQuoteItem ||
                  loadingConvertQuote ||
                  quoteProductsLoading ||
                  loadingCustomerPushCart ||
                  loadingActiveMagentoCart ||
                  loadingAddItemsToQuote ||
                  loadingQuoteTotals ||
                  loadingPatientsGroupCart ||
                  loadingCheckout;

  useEffect(() => {
    if (!currentMarketingSegment?.value) {
      history.push('/quoting');
    }

    if (currentMarketingSegment?.value && !patientsGroupCart?.length) {
      history.push(`/quoting/group/${currentMarketingSegment?.value}`);
    }
  }, [currentMarketingSegment?.value, patientsGroupCart?.length]);

  useEffect(() => {
    dispatch(setFinalPageData([], 30));

    if (!quoteProducts.length) {
      getQuoteProProductsBySearchCriteriaApi({
        dispatch,
        sortDirection: 'asc',
        sortField: 'name',
        pageSize: '',
        currentPage: '',
        filterConditions: [
          {
            field: 'status',
            value: '1',
            conditionType: 'eq'
          },
        ],
        searchConditions: []
      });
    }
  }, []);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote', path: '/quoting'},
            isPatientGroupActive ?
              { name: 'Marketing Segment Details', path: `/quoting/group/${currentMarketingSegment?.value}` } :
              { name: `${isCustomer3 ? 'Customer' : 'Patient'} Details`, path: `/quoting/profile/${currentMarketingSegment?.value}` },
            { name: 'Quote Workspace', path: `/quoting/group/${currentMarketingSegment?.value}/quote-workspace` },
            { name: 'Quote Summary' }
          ]}
        />
      </div>
      <Grid container spacing={3} className="px-8">
        <Grid item xs={12} md={8}>
          {!!patientsGroupCart?.length &&
            <QuoteSummaryTable />
          }
        </Grid>
        <Grid item xs={12} md={4}>
          {isPatientGroupActive ?
            <QuoteGroupInfo /> :
            <QuoteSummaryPatient />
          }
          <br />
          <QuotePatientGroupSummaryCard />
        </Grid>
      </Grid>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default QuoteGroupPatientsSummary;
